import { render, staticRenderFns } from "./platinvoicingtasklist.vue?vue&type=template&id=ad3e0198&"
import script from "./platinvoicingtasklist.vue?vue&type=script&lang=js&"
export * from "./platinvoicingtasklist.vue?vue&type=script&lang=js&"
import style0 from "./platinvoicingtasklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports